var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66699C8.64033 2.66699 2.66699 8.64033 2.66699 16.0003C2.66699 23.3603 8.64033 29.3337 16.0003 29.3337C23.3603 29.3337 29.3337 23.3603 29.3337 16.0003C29.3337 8.64033 23.3603 2.66699 16.0003 2.66699ZM9.42699 24.3737C10.0003 23.1737 13.4937 22.0003 16.0003 22.0003C18.507 22.0003 22.0137 23.1737 22.5737 24.3737C20.7603 25.8137 18.4803 26.667 16.0003 26.667C13.5203 26.667 11.2403 25.8137 9.42699 24.3737ZM24.4803 22.4403C22.5737 20.1203 17.947 19.3337 16.0003 19.3337C14.0537 19.3337 9.42699 20.1203 7.52033 22.4403C6.16033 20.6537 5.33366 18.427 5.33366 16.0003C5.33366 10.1203 10.1203 5.33366 16.0003 5.33366C21.8803 5.33366 26.667 10.1203 26.667 16.0003C26.667 18.427 25.8403 20.6537 24.4803 22.4403ZM16.0003 8.00033C13.4137 8.00033 11.3337 10.0803 11.3337 12.667C11.3337 15.2537 13.4137 17.3337 16.0003 17.3337C18.587 17.3337 20.667 15.2537 20.667 12.667C20.667 10.0803 18.587 8.00033 16.0003 8.00033ZM16.0003 14.667C14.8937 14.667 14.0003 13.7737 14.0003 12.667C14.0003 11.5603 14.8937 10.667 16.0003 10.667C17.107 10.667 18.0003 11.5603 18.0003 12.667C18.0003 13.7737 17.107 14.667 16.0003 14.667Z",
    fill: "#2D4BF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidents);
export default __webpack_public_path__ + "static/media/residents.87d9eb68cd2f408b184a51dc16b93424.svg";
export { ForwardRef as ReactComponent };